import { render } from "@/share/components/controls/svgIcon/SVGIcon.html?vue&type=template&id=5e2a1bd5&scoped=true&external"
import script from "@/share/components/controls/svgIcon/SVGIcon.js?vue&type=script&lang=js&external"
export * from "@/share/components/controls/svgIcon/SVGIcon.js?vue&type=script&lang=js&external"

import "@/share/components/controls/svgIcon/SVGIcon.scss?vue&type=style&index=0&id=5e2a1bd5&lang=scss&scoped=true&external"

import exportComponent from "../../../../execute/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2a1bd5"]])

export default __exports__